import Vue from 'vue'
import App from './App.vue'
import router from './router'

import "katex/dist/katex.min.css"

import 'normalize.css/normalize.css'
//import 'latex.css/style.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import "@fontsource/source-sans-pro";


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
